import { render, staticRenderFns } from "./ProductionDetailDialog.vue?vue&type=template&id=a85dd4ac"
import script from "./ProductionDetailDialog.vue?vue&type=script&lang=js"
export * from "./ProductionDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports